import { render } from "./VisionView.vue?vue&type=template&id=dddaf110&scoped=true"
import script from "./VisionView.vue?vue&type=script&lang=js"
export * from "./VisionView.vue?vue&type=script&lang=js"

import "./VisionView.vue?vue&type=style&index=0&id=dddaf110&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dddaf110"]])

export default __exports__